// script.js (cone index.html) ~sdg
'use strict'
console.time('LoadTime')
// Imports
import './normalize.css'
import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { MeshBasicMaterial } from 'three'

// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()

/**
 * Sizes
 */
const sizes = { width:window.innerWidth, height:window.innerHeight }
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Cameras
 */
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 3
camera.position.y = 3
camera.position.z = 8
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 2
controls.maxDistance = 90

// Renderer
const renderer = new THREE.WebGLRenderer({ canvas:canvas, alpha:true })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio( Math.min(window.devicePixelRatio, 2) )
renderer.setClearColor('hsl(120, 100%, 98%)') // very light green

/**
 * Particles
 */
// Geometry
const particlesGeometry = new THREE.BufferGeometry()
const count = 3000
const positions = new Float32Array(count * 3)
for (let i = 0; i < count * 3; i++) {
  positions[i] = (Math.random() - 0.5) * 10
}
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
// Material
const particlesMaterial = new THREE.PointsMaterial({
  color: 'hsl(120, 100%, 25%)', // green
  size: 0.03,
  sizeAttenuation: true
})
particlesMaterial.depthWrite = false
// Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)

/**
 * Objects
 */
// Textures & Materials
const textureLoader = new THREE.TextureLoader()
const flowerTexture = textureLoader.load('./textures/pictures/flower.jpg')
const flowerMaterial = new MeshBasicMaterial({ map: flowerTexture })
flowerMaterial.side = THREE.DoubleSide
// Cone
const cone = new THREE.Mesh(new THREE.ConeGeometry(1, 2, 8, 1, true), flowerMaterial)
cone.rotation.z = Math.PI * 0.3
scene.add(cone)

/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()
  // Update Controls
  controls.update()
  // Rotate Particles
  particles.rotation.z = 0.05 * elapsedTime
  // Rotate Cone
  cone.rotation.y = 0.2 * elapsedTime
  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (cone index.html) ~sdg